import ModalUtil from 'common/util/ModalUtil';
import CartUtil from 'common/util/CartUtil';
import CurrencyUtil from "common/util/CurrencyUtil";

import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class orderCart {
    static classname = 'order-cart-decorator';
    #orderCart = $();
    #decorator = $();
    #orderCartSelector = '#js-order-cart'
    #decoratorSelector = '.order-cart-decorator';
    #decoratorClassReady = 'order-cart-decorator_ready';
    #productToDelete = $();
    #cartItemsData = {};

    constructor($decorator) {
        this.#decorator = $decorator;
        this.#orderCart = $decorator.find(this.#orderCartSelector);
        this.#cartItemsData = JSON.parse($decorator.find('#cart_items_data').val());
        this.initEventListeners();
        this.decorate();
    }

    initEventListeners() {
        this.#orderCart.get(0).addEventListener('click', (e) => {

            const deleteBtn = e.target.closest('.js-delete-product');

            if (deleteBtn !== null) {
                this.#productToDelete = $(deleteBtn.closest('.wa-product'));
            }
        }, true);

        this.#orderCart.on('wa_order_cart_rendered', (event, data) => {
            this.updateInfoOrder(data);
            this.updateBasketInfo(data);
            this.setProductPrices();
            this.transferPlugins();
        })

        window.ObserverUtil.observe('delete', () => {
            this.initFavoriteBtn();
            this.initDeleteBtn();
        });

        $(document).on('confirm_modal', () => {
            ModalUtil.close()
            this.removeProduct();
        })

        const $window = $(window);

        $window.on('resize', () => {
            const $btns = this.#orderCart.find('.order-cart-decorator__accessories');
            if ($window.width() > 900) {
                $btns.each(function () {
                    const $btn = $(this);

                    if ($btn.closest('.wa-details').length) {
                        return
                    }

                    const $parent = $btn.closest('.wa-product-body');
                    $parent.find('.wa-details').append($btn);
                })
            } else {
                $btns.each(function () {
                    const $btn = $(this);

                    if (!$btn.closest('.wa-details').length) {
                        return
                    }

                    $btn.closest('.wa-product-body').append($btn);
                })
            }
        })

        window.ObserverUtil.observe('flexdiscount-discounts-body', ($node) => {
            $node.find('li').each(function () {
                const $li = $(this);
                $li.html($li.html().replace('-',''))
            });
        })
    }

    decorate() {
        this.#decorator.removeClass(this.#decoratorClassReady);
        this.initAccessories();
        this.initFavoriteBtn();
        this.initDeleteBtn();
        this.setProductPrices();
        this.transferPlugins();

        if (!this.#orderCart.find('.order-cart-info').length) {
            const $infoOrder = this.addInfoOrder();
            this.setGlobalDiscount($infoOrder.data('discount'));
        }

        this.#decorator.addClass(this.#decoratorClassReady);
    }

    initAccessories() {
        if (!this.#orderCart.data('accessories')) {
            return;
        }

        function openModal() {
            const productID = $(this).closest('.wa-product').data('product-id');
            const url = `${elkitorg_config.elkihelper_accessories_modal_url}?product_id=${productID}&limit=30`;
            ModalUtil.openAjax(url);
        }

        this.#orderCart.find('.wa-product').each(function () {
            const $product = $(this);

            if ($product.find('.order-cart-decorator__accessories').length) {
                return;
            }

            const $link = $('<div class="order-cart-decorator__accessories">' +
                '<span class="order-cart-decorator__accessories-text">Подобрать аксессуары</span>' +
                '</div>');

            $link.on('click', openModal);

            if ($(window).width() < 900) {
                $product.find('.wa-product-body').append($link);
            } else {
                $product.find('.wa-details').append($link);
            }
        });
    }

    addInfoOrder() {
        const $orderInfo = $(this.#orderCart.find('#order-cart-info').prop('content').cloneNode(true).firstChild);
        $orderInfo.insertAfter('.wa-cart-details .wa-column-content');
        return $orderInfo
    }

    updateInfoOrder({cart}) {
        let $info = this.#orderCart.find('.order-cart-info');

        if (!$info.length) {
            $info = this.addInfoOrder();
        }

        $info.find('.row-value_price .row-value__value-text').html(this.priceToHtml(parseFloat(cart.subtotal)));
        $info.find('.row-value_weight .row-value__value-text').text(cart.total_weight_html);
        $info.find('.row-value_weight .row-value__label-container .count').text(cart.count);

        let totalDiscount = cart.discount;

        for (let key in cart.items) {
            const {full_compare_price, full_price} = cart.items[key]

            if (full_compare_price !== 0) {
                totalDiscount += full_compare_price - full_price
            }
        }

        let $discountBlock = $info.find('.row-value_discount');

        if (totalDiscount === 0) {
            this.setGlobalDiscount();
            $discountBlock.remove();
            return;
        }

        if (!$discountBlock.length) {
            $discountBlock = $(
                '<div class="row-value row-value_discount">' +
                '<div class="row-value__label-container">' +
                '<div class="row-value__label-text">Скидка на товары</div>' +
                '</div>' +
                '<div class="row-value__value-container">' +
                '<span class="row-value__value-text"></span>' +
                '</div>' +
                '</div>');

            $info.append($discountBlock);
        }
        const htmlDiscount = this.priceToHtml(totalDiscount);
        this.setGlobalDiscount(htmlDiscount);
        $discountBlock.find('.row-value__value-text').html(this.priceToHtml(totalDiscount));
    }

    updateBasketInfo({cart}) {
        this.#decorator.trigger('shop_cart_update', {status: 'ok', data: {total: this.priceToHtml(cart.total), count: cart.count}});
    }

    removeProduct() {
        if (!this.#productToDelete.length) {
            return
        }

        CartUtil.deleteItem(this.#productToDelete.data('id')).then(() => {
            this.#productToDelete.slideUp('slow', () => {
                this.#productToDelete = $();
                this.#decorator.trigger('remove_product');
            });
        });
    }

    initFavoriteBtn() {
        const isInitialized = this.#orderCart.find('.order-cart-decorator__favorite').length > 0;

        if (isInitialized) {
            return;
        }

        const $favoriteBtn = $(`<span class="order-cart-decorator__favorite js-favorite-button bottom" data-title="Добавить в избранное" 
            data-title-success="Удалить из избранного">${elkitorg_config.svg.heart}</span>`)
        this.#orderCart.find('.wa-product').each(function () {
            const $product = $(this);
            const $favoriteProductBtn = $favoriteBtn.clone();
            $favoriteProductBtn.attr('data-product-id', $product.data('product-id'));
            $favoriteProductBtn.attr('data-product-name', $product.find('.wa-name').text());
            $favoriteProductBtn.attr('data-product-image', $product.find('.wa-image-section img').attr('src'));
            $product.find('.wa-quantity-actions .wa-actions').prepend($favoriteProductBtn);
        })
    }

    initDeleteBtn() {
        const deleteIcon = elkitorg_config.svg.trash;
        this.#orderCart.find('.wa-quantity-actions .js-delete-product').each(function () {
            $(this).html(deleteIcon);
        });
    }

    setProductPrices() {
        this.#orderCart.find('.wa-product').each((ind, product) => {
            const $product = $(product);
            const dataId = $product.data('id')
            const comparePrice = this.#cartItemsData[dataId] && this.#cartItemsData[dataId]['compare_price'];
            const $priceCompare = $product.find('.wa-price-compare');
            const $totalPrice = $product.find('.wa-price-total');
            const isComparePriceAvailable = parseFloat($priceCompare.html().replace(',', '.')) > 0

            if (isComparePriceAvailable && comparePrice === undefined) {
                $totalPrice.addClass('wa-price-total_red');
            } else if (comparePrice !== undefined) {
                $totalPrice.addClass('wa-price-total_red');
                const calculatedComparePrice = comparePrice * parseInt($product.find('.js-product-quantity').val());
                $priceCompare.html(this.priceToHtml(calculatedComparePrice));
                $priceCompare.show();
            } else {
                $totalPrice.removeClass('wa-price-total_red');
                $priceCompare.hide();
            }
        })
    }

    transferPlugins() {
        const $pluginHook = this.#orderCart.find('.wa-plugin-hook');
        this.#orderCart.find('.wa-cart-details .wa-column-price').before($pluginHook);
    }

    priceToHtml(price = '') {
        return CurrencyUtil.format(price, elkitorg_config.currency_info[elkitorg_config.currency], false)
    }

    setGlobalDiscount(discount) {
        window.discount = discount;
        this.#decorator.trigger('set_discount');
    }
}